if (!window.MomcozyModalInit) {
  window.MomcozyModalInit = true;
  document.addEventListener('DOMContentLoaded', function () {
    /* Open modal */
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-momcozy-modal]');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        var modalId = trigger.getAttribute('data-momcozy-modal');
        var modal = document.getElementById(modalId);
        if (modal) {
          modal.classList.add('active');
          document.body.style.overflow = 'hidden';
        }
      }
    });

    /* Close modal: click overlay */
    document.addEventListener('click', function (e) {
      if (e.target.matches('[data-momcozy-modal-overlay]')) {
        closeModal(e.target);
      }
    });

    /* Close modal: close button */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-momcozy-modal-close]');
      if (btn) {
        var modal = btn.closest('[data-momcozy-modal-overlay]');
        closeModal(modal);
      }
    });

    /* Close modal: Escape key */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('[data-momcozy-modal-overlay].active').forEach(function (modal) {
          closeModal(modal);
        });
      }
    });

    function closeModal(modal) {
      if (!modal) return;
      modal.classList.remove('active');
      document.body.style.overflow = '';
    }
  });
}